// SPDX-License-Identifier: AGPL-3.0-or-later
// SPDX-FileCopyrightText: 2026 Ben Richardson <hi@ben.gy>
//
// The single source of truth for party colour and labelling. Every view imports
// from here so a party is the SAME colour in the map, pendulum, bars, Sankey,
// matrix and drill-down. Colours follow the conventional Australian palette.

export type Group = 'ALP' | 'COA' | 'GRN' | 'IND' | 'OTH';

export const GROUP_META: Record<Group, { label: string; short: string; color: string }> = {
  ALP: { label: 'Labor', short: 'ALP', color: '#e0403f' },
  COA: { label: 'Coalition', short: 'L/NP', color: '#1c4fa1' },
  GRN: { label: 'Greens', short: 'GRN', color: '#10a64a' },
  IND: { label: 'Independent', short: 'IND', color: '#14b8a6' },
  OTH: { label: 'Other', short: 'OTH', color: '#e0892b' },
};

export const GROUP_ORDER: Group[] = ['ALP', 'COA', 'GRN', 'IND', 'OTH'];

// Conventional colours for individual parties that appear by name (first
// preferences, preference flows). Falls back to the group colour otherwise.
const PARTY_COLORS: Record<string, string> = {
  ALP: '#e0403f',
  LP: '#1c4fa1',
  LNP: '#1c4fa1',
  LNQ: '#1c4fa1',
  NP: '#0a7d3f', // Nationals — traditional dark green
  CLP: '#f47b20',
  GRN: '#10a64a',
  IND: '#14b8a6',
  ON: '#f4820f', // One Nation orange
  KAP: '#8f2f4a', // Katter maroon
  XEN: '#ff9d00', // Centre Alliance
  CYA: '#7a5195', // Trumpet of Patriots
  FFP: '#5b3f8c', // Family First
  HMP: '#4caf50', // Legalise Cannabis
  LTP: '#c9a227', // Libertarian
};

export function groupColor(g: Group): string {
  return GROUP_META[g].color;
}

export function groupLabel(g: Group): string {
  return GROUP_META[g].label;
}

export function partyColor(ab: string, group: Group): string {
  return PARTY_COLORS[ab] ?? GROUP_META[group].color;
}
